// extracted by mini-css-extract-plugin
module.exports = {"list":"MenuList_list__RBP7l"};